import React from 'react';
import { Typography } from '@mui/material';
import { MoSpacing } from '@motivo/guanyin/src/components';
import { ResultOf } from ':src/graphql';
import { userDetailsByIdQuery } from '../../graphql/queries';
import { Section } from '../Section';
import LicenseText from './LicenseText';

type User = NonNullable<ResultOf<typeof userDetailsByIdQuery>['userById']>;

interface LicensesSectionProps {
  user: User;
}

export default function LicensesSection({ user }: LicensesSectionProps) {
  const licenseCount = user.usersLicenses.length;

  return (
    <Section
      title="Licenses"
      count={licenseCount > 0 ? licenseCount : undefined}
      summaryLink={{
        label: 'View all credentials in Zeus →',
        path: `/users/${user.id}/credentials`,
      }}
    >
      {licenseCount === 0 ? (
        <Typography color="textSecondary">No licenses on file</Typography>
      ) : (
        <MoSpacing y={0.5}>
          {user.usersLicenses.map((userLicense) => (
            <LicenseText
              key={userLicense.id}
              stateAbbreviation={userLicense.usState.abbreviation}
              licenseDisplayName={userLicense.license.displayName}
            />
          ))}
        </MoSpacing>
      )}
    </Section>
  );
}
